import * as v from 'valibot'

export const defaultEventsSearch = {
  page: 0,
  size: 10 as const,
  sort_by: 'date' as const,
  order: 'desc' as const,
  search: '',
  event_state: 'all' as const,
  event_types: [] as Array<'in_person' | 'online'>,
  selected_ids: [] as string[],
  show_selected: false,
  dialog_ids: [] as string[],
}

const filterOptionSchema = v.object({
  id: v.string(),
  label: v.string(),
})

const compatibleFilterOptionSchema = v.union([filterOptionSchema, v.string()])

export const eventsSearchParamsSchema = v.object({
  page: v.optional(v.number(), defaultEventsSearch.page),
  size: v.optional(v.picklist([10, 25, 50]), defaultEventsSearch.size),
  sort_by: v.optional(
    v.picklist(['title', 'completed', 'date']),
    defaultEventsSearch.sort_by,
  ),
  order: v.optional(v.picklist(['asc', 'desc']), defaultEventsSearch.order),
  search: v.optional(v.string(), defaultEventsSearch.search),
  event_state: v.optional(
    v.picklist([
      'upcoming',
      'in_progress',
      'active',
      'unassigned',
      'overdue',
      'all',
    ]),
    defaultEventsSearch.event_state,
  ),
  event_types: v.optional(
    v.array(v.picklist(['in_person', 'online'])),
    defaultEventsSearch.event_types,
  ),
  // Preserve the legacy overview's search values while the flag is disabled.
  state: v.optional(v.any()),
  type: v.optional(v.any()),
  types: v.optional(v.any()),
  owner: v.optional(v.literal('me')),
  group: v.optional(compatibleFilterOptionSchema),
  user: v.optional(compatibleFilterOptionSchema),
  selected_ids: v.optional(
    v.array(v.string()),
    defaultEventsSearch.selected_ids,
  ),
  show_selected: v.optional(v.boolean(), defaultEventsSearch.show_selected),
  dialog: v.optional(v.picklist(['delete', 'duplicate'])),
  dialog_ids: v.optional(v.array(v.string()), defaultEventsSearch.dialog_ids),
})

export type EventsSearch = v.InferOutput<typeof eventsSearchParamsSchema>
export type EventsSort = EventsSearch['sort_by']

export function normalizeEventFilterOption(
  option: EventsSearch['group'] | EventsSearch['user'],
) {
  if (!option) return undefined
  if (typeof option !== 'string') return option

  const separatorIndex = option.indexOf(':')
  if (separatorIndex < 0) return undefined

  return {
    id: option.slice(0, separatorIndex),
    label: option.slice(separatorIndex + 1),
  }
}
